import { render, staticRenderFns } from "./CreatePage.vue?vue&type=template&id=81f3eae2&"
import script from "./CreatePage.vue?vue&type=script&lang=ts&"
export * from "./CreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81f3eae2')) {
      api.createRecord('81f3eae2', component.options)
    } else {
      api.reload('81f3eae2', component.options)
    }
    module.hot.accept("./CreatePage.vue?vue&type=template&id=81f3eae2&", function () {
      api.rerender('81f3eae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trucking/sales-order/CreatePage.vue"
export default component.exports